import styles from './RatingContainer.scss';
import withClassName from '../../../../utils/withClassName';

export default withClassName(styles.container)('div');
